export const BFF_ERROR_CODES = {
  INVALID_COMPANIES: 'invalid_companies',
  INVALID_TOKEN: 'invalid_token',
  INVALID_TOKEN_REFRESH: 'invalid_token_refresh',
  INVALID_CONNECTION_ID: 'invalid_connection_id',
  INVALID_USER_STATE: 'invalid_user_state',
  INVALID_JWT_ACCESS_TOKEN: 'invalid_jwt_access_token',
  INVALID_JWT_REFRESH_TOKEN: 'invalid_jwt_refresh_token',
  INVALID_REFRESH_TOKEN_COOKIE_NOT_FOUND: 'invalid_refresh_token_cookie_not_found',
  NOT_FOUND_AUTHORIZATION_OR_COOKIE: 'not_found_authorization_or_cookie',
  SESSION_EXPIRED: 'session_expired',
  CONVERSATION_EXPIRED: 'conversation_expired',
  ATTENDANCE_ALREADY_ARCHIVED: 'attendance_already_archived',
};
